import { Link, Typography } from '@mui/material'
import { tss } from 'tss-react/mui'
import { TextProps, TypographyVariant } from '../types'
import { getLinkStyles } from './primitives'

/**
 * Renders a styled link
 */
export const LinkText = ({
  typography = 'body1',
  href,
  className,
  underline = 'always',
  ...rest
}: Omit<TextProps, 'variant'> & Required<Pick<TextProps, 'href'>>) => {
  const { cx, classes } = useStyles({ typography })
  return (
    <Link className={cx(classes.root, className)} href={href} target="_blank" underline={underline}>
      <Typography {...rest}>{rest.content}</Typography>
      {rest.children}
    </Link>
  )
}

const useStyles = tss
  .withParams<{ typography: TypographyVariant }>()
  .create(({ typography, theme }) => ({
    root: getLinkStyles(typography, theme),
  }))
